// extracted by mini-css-extract-plugin
module.exports = {"input":"ModalCadastroCurso_input__3k7dG","linhaSalvar":"ModalCadastroCurso_linhaSalvar__LYvyP","alerta":"ModalCadastroCurso_alerta__gYxek"};